export type Branding = {
  clientBrand?: string
  logoSrc: string
  logoHeight?: number
}

const defaultBranding: Branding = {
  clientBrand: '#5c3cd8',
  logoSrc: '/logo192.png',
  logoHeight: 24,
}

const kenyaMoeBranding: Branding = {
  clientBrand: '#00aeee',
  logoSrc: '/kenya-moe-logo.png',
}

const landscapingProjectOrgId = '89049ab4-0e99-4008-bebd-58e5634b2067'

export const getBranding = (organizationId: string | undefined): Branding =>
  organizationId === landscapingProjectOrgId ? kenyaMoeBranding : defaultBranding
